import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AllInclusiveIcon(props: IconProps) {
    return <Icon {...props} iconKey={"all_inclusive"}/>
}
